<template>
  <div>
    <lk-table :columns='columns' :data='row.assertsCuringHistoryVOs' class="mytable"/>
  </div>
</template>
<script>
import utils from '../../libs/utils';
import Uploader from '../../components/Uploader.vue';

export default {
  props: {
    row: Object,
  },
  components: {
  },
  mounted() {
    // console.log(this.row);
  },
  data() {
    return {
      columns: [
        {
          title: '设备编码',
          minWidth: 116,
          key: 'assertsCode',
          render: (h, { row }) => {
            let content = '';
            if (!row.assertsCode) {
              content = '-';
            } else {
              content = row.assertsCode;
            }
            return h('div', content);
          },
        },
        {
          title: '设备名称',
          minWidth: 116,
          key: 'assertsName',
          render: (h, { row }) => {
            let content = '';
            if (!row.assertsName) {
              content = '-';
            } else {
              content = row.assertsName;
            }
            return h('div', content);
          },
        },
        {
          title: '型号',
          minWidth: 116,
          key: 'unitType',
          render: (h, { row }) => {
            let content = '';
            if (!row.unitType) {
              content = '-';
            } else {
              content = row.unitType;
            }
            return h('div', content);
          },
        },
        {
          title: '生产厂家',
          minWidth: 116,
          key: 'manufacturer',
          render: (h, { row }) => {
            let content = '';
            if (!row.manufacturer) {
              content = '-';
            } else {
              content = row.manufacturer;
            }
            return h('div', content);
          },
        },
        {
          title: '检测机构',
          minWidth: 116,
          key: 'inspectionMechanism',
          render: (h, { row }) => {
            let content = '';
            if (!row.inspectionMechanism) {
              content = '-';
            } else {
              content = row.inspectionMechanism;
            }
            return h('div', content);
          },
        },
        {
          title: '检测完成时间',
          key: 'inspectionTime',
          minWidth: 116,
          render: (h, { row }) => {
            let content = '';
            if (!row.inspectionTime) {
              content = '-';
            } else {
              content = utils.formatTime(row.inspectionTime, 'YYYY/MM/DD');
            }
            return h('div', content);
          },
        },
        {
          title: '检测结果',
          key: 'inspectionResultStr',
          minWidth: 116,
          render: (h, { row }) => {
            let content = '';
            if (!row.inspectionResultStr) {
              content = '-';
            } else {
              content = row.inspectionResultStr;
            }
            return h('div', content);
          },
        },
        {
          title: '检测备注',
          key: 'curingDescription',
          minWidth: 116,
          render: (h, { row }) => {
            let content = '';
            if (!row.curingDescription) {
              content = '-';
            } else {
              content = row.curingDescription;
            }
            return h('div', content);
          },
        },
        {
          title: '检测报告',
          key: 'picUrl',
          minWidth: 116,
          render: (h, { row }) => {
            if (!row.picUrl) {
              return h('div', '-');
            }

            return h(Uploader, {
              props: {
                url: row.picUrl || '',
                // canDelete: false,
                able: false,
              },
            });
          },
        },
      ],
    };
  },
};
</script>
<style lang="less" scoped>

</style>
